window.addEventListener('load', function() {
  setTimeout(function() {
    var script = document.createElement('script');
    script.src = 'https://consent.cookiebot.com/uc.js';
    script.setAttribute('data-cbid', '0448d7cb-13f7-4a8a-9f20-85dfe1940427');
    script.type = 'text/javascript';
    script.async = true;  // Ensure the script loads asynchronously
    document.body.appendChild(script);
  }, 2000); // Delay loading by 2 seconds
});